import React from "react"
import "./style.scss"
import AniLink from "gatsby-plugin-transition-link/AniLink"

function Hero() {
  return (
    <div className="hero">
      <div className="heroContainer">
        <div className="container" style={{ zIndex: 13 }}>
          <div className="heroContent">
            <div className="row flex-column-reverse flex-md-row">
              <div className="px-3 px-md-0 ps-md-4 col-12 col-md-6 col-xl-5 d-flex flex-column justify-content-center align-items-start py-4">
                <div className="text-center">
                  <div className="heroBigText1">We Make Your Brand</div>
                  <div className="heroBigText2">Stand Out</div>
                </div>
                <p>
                  We develop innovative solutions for all your tech projects, be
                  it custom software development, web development, mobile app
                  development, web scraping or UI/UX design, we use the latest
                  cutting-edge technologies that will meet the needs of future
                </p>
                <AniLink
            paintDrip
            hex="#551864"
                  to="/getQuote"
                  className="connectWithUs fs-4 mt-3 px-4 py-2"
                  style={{ borderRadius: "22px" }}
                  onMouseOver={() => {}}
                >
                  Connect with us
                </AniLink>
              </div>
              <div className="col-2 d-none d-md-flex"></div>
              <div className="col-12 col-md-5 d-flex justify-content-center align-items-center py-4">
                <img loading="lazy" 
                  src="/images/heroImage.webp"
                  alt=""
                  width="450px"
                  className="img-fluid py-3 heroImage px-5 px-md-0"
                />
              </div>
            </div>
          </div>
        </div>
        <div className="container d-flex justify-content-center align-items-center pt-2">
          <i
            className="bi bi-chevron-compact-down fs-1"
            style={{ marginBottom: "-20px", opacity: "0.7" }}
          ></i>
        </div>
      </div>
      <div className="heroBottomWave">
        <img loading="lazy"  src="/images/wave_hero.svg" alt="wavehero" width="100%" />
      </div>
    </div>
  )
}

export default Hero
